import React from 'react';
import PropTypes from 'prop-types';

const QA = ({ items, ...rest }) => {
  const hasItems = !!items.length;

  if (!hasItems) {
    return null;
  }

  return (
    <div className='qa' {...rest}>
      <div className='qa__container'>
        {items.map((item, index) => {
          const { question, answer } = item;
          return (
            <React.Fragment key={index}>
              <div className='qa__question' dangerouslySetInnerHTML={{ __html: question }} />
              <div className='qa__answer' dangerouslySetInnerHTML={{ __html: answer }} />
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

QA.propTypes = {
  items: PropTypes.array,
};

export default QA;
